import { use } from 'react'
import { ToasterContext } from './ToasterContext'

export function useToasterContext() {
  const context = use(ToasterContext)

  if (!context) {
    throw new Error('useToasterContext must be used within a ToasterProvider')
  }

  return context
}
